import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import DynamicRewardsTabContent from 'core/modules/DynamicRewardsTabContent/DynamicRewardsTabContent';
import TabNavigationTitles from './components/TabNavigationTitles/TabNavigationTitles';

function TabNavigation({ tab_navigation: tabNavigationProp }) {
  const [activeTabLink, setActiveTabLink] = useState('');

  const parseTabsNavigationData = tabs => (
    JSON.parse(tabs)
  );

  const tabNavigation = parseTabsNavigationData(tabNavigationProp);

  if (isEmpty(tabNavigation)) {
    return null;
  }

  return (
    <>
      <TabNavigationTitles
        tabNavigation={tabNavigation}
        setActiveTabLink={setActiveTabLink}
      />
      <DynamicRewardsTabContent activeTabLink={activeTabLink} />
    </>
  );
}

export default (props) => <ComponentErrorBoundary><TabNavigation {...props} /></ComponentErrorBoundary>;
